<mat-dialog-content>
  <p class="text-center" *ngIf="context==='Rule'">Voulez-vous vraiment supprimer cette règle ?</p>
  <p class="text-center" *ngIf="context==='Category'">Voulez-vous vraiment supprimer cette catégorie ?</p>
  <p class="text-center" *ngIf="context==='Intervalle'">Voulez-vous vraiment supprimer cet intervalle ?</p>
  <p class="text-center" *ngIf="context==='Promo'">Voulez-vous vraiment supprimer cette promotion ?</p>
  <p class="text-center" *ngIf="context==='OrderConfirm'">Voulez-vous vraiment confirmer cette commande ?</p>
  <p class="text-center" *ngIf="context==='OrderCancel'">Voulez-vous vraiment annuler cette commande ?</p>
  <p class="text-center" *ngIf="context==='OrderGenerate'">Voulez-vous vraiment générer le ticket pour cette commande ?</p>
  <p class="text-center" *ngIf="context==='menue' || context ==='product'">Voulez-vous vraiment supprimer cet composant ?</p>
  <p class="text-center" *ngIf="context==='menu' ">Voulez-vous vraiment supprimer cet groupe ?</p>
  <p class="text-center" *ngIf="context==='unlock' ">Voulez-vous vraiment débloquer ce client ?</p>

  <div class="flex justify-center items-center gap-2">
    <button mat-button class="save w-full" (click)="dialogRef.close(true)">Oui</button>
    <button (click)="dialogRef.close(false)" mat-button class="w-full reset">Non</button>
  </div>
</mat-dialog-content>
